import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-iquanta-initiative',
  templateUrl: './iquanta-initiative.component.html',
  styleUrls: ['./iquanta-initiative.component.scss']
})
export class IquantaInitiativeComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) { }

  ngAfterViewInit() {
   
  }
  ngOnInit() {
   
    this.titleService.setTitle('iQuanta Social Initiative - Free Education');
    this.metaService.updateTag(
       {name:'title', property: 'og:title', content: 'iQuanta Social Initiative - Free Education'})
       this.metaService.updateTag(
         {name:'url', property: 'og:url', content: 'https://www.iquanta.in/iquanta-initiative'})
     this.metaService.updateTag(
     {name:'description', property: 'og:description', content: "To make education accessible to all, we launched the Free Education initiative in 2017.  iQuanta has adopted two villages, provide free education to over 1500 students."});
 
     this.metaService.updateTag(
       {property: 'twitter:title', content: 'iQuanta Social Initiative - Free Education'})
       this.metaService.updateTag(
         {property: 'twitter:url', content: 'https://www.iquanta.in/iquanta-initiative'})
     this.metaService.updateTag(
     {property: 'twitter:description', content: "To make education accessible to all, we launched the Free Education initiative in 2017.  iQuanta has adopted two villages, provide free education to over 1500 students."});
     this.metaService.updateTag(
      {name:'image', property: 'og:image', content: 'https://media.iquanta.in/ui_images/previewimages/iQuanta_village_adoption.jpg'})
      this.metaService.updateTag(
        {property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/previewimages/iQuanta_village_adoption.jpg'})
  }

}
